import {path} from 'ramda';
import namespace from './namespace';

const root = path(namespace);

export const notifications = root;
